import { all, takeEvery } from 'redux-saga/effects';
import * as TYPE from './types';
import { loginLineSaga } from './api';

function* authSaga() {
  yield all([takeEvery(TYPE.AUTHEN_LOGIN_LINE_REQ, loginLineSaga)]);
}

export default authSaga;
